import script from "./SideMenuBigFlexButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuBigFlexButtons.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuBigFlexButtons.vue?vue&type=style&index=0&id=09199b68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09199b68"]])

export default __exports__